<template>
    <div class="game">
      <game-intro v-if="setupGame.gameView == 1"></game-intro>
      <game-lvl v-if="setupGame.gameView == 3"></game-lvl>
      <game-rules v-if="setupGame.gameView == 2"></game-rules>
      <game-map v-if="showGameMap" :stepOrder="'game_one'"></game-map>
      <game-order v-if="showGameAccess" :orderType="1"></game-order>
      <mission-name v-if="setupGame.gameView != 1" v-bind:hangmanGame="hangmanGame" :mission-name="hangmanGame.missionName" :mission-title="hangmanGame.gameName"></mission-name>
      <div class="game-store" v-if="setupGame.gameView == 4 & !showGameAccess & !showGameMap">
        <life-status ref="lifes" v-if="showGame" :lifes="life"></life-status>
        <game-timer v-if="showGame" :stop="stopTimer" :timeLimit="60" :timeWrong="30" :stopTimer="false"  @lifeDown="lifeDown = $event" @showMessage="showMessage = $event"></game-timer>
        <div class="end-game-mask" v-if="gameOver">
          <div class="wrap-end-game">
            <div class="spider"></div>
            <div class="benia">
              <div class="message-box left message-300">
                <div class="top"></div>
                  <div class="wrap left">
                    <h3>Koniec gry.<br />Spróbuj jeszcze raz.</h3>
                  </div>
                <div class="bottom"></div>
              </div>
            </div>
            <div class="action-bar">
              <button class="btn btn-green-light" @click="resetGame(3)"><span>Spróbuj jeszcze raz</span></button>
            </div>
          </div>
        </div>
        <div class="game-store_wrap">
          <div v-if="showLabel">
            <div class="explanation-block">
              <div class="retry">
                <button @click="rePlay()" class="btn retry-animation">
                  <i ref="retryIcon" class="retry-icon"></i>
                </button>
              </div>
              <div class="wrap">
                 <div class="explanation-card" ref="cardinfo">
                   <img :src="require(`@/assets/images/dictionary_assets/${card.img}`)">
                   <div class="action-bar">
                     <button class="btn btn-green" id="btnNexStep" v-if="!endGame" @click="goNextStep()"><span>NASTĘPNE SŁOWO</span></button>
                     <button id="nextGame" class="btn btn-green" v-if="endGame" @click="goNextGame()"><span>PRZEJDŹ DALEJ</span></button>
                   </div>
                 </div>
              </div>
            </div>
          </div>
          <div class="hangman">
            <div class="benia benia-200 hide-mob" v-if="!showLabel"></div>
            <div class="ducks right duck-120 hide-mob" v-if="!showLabel">
              <div class="message-box left message-200" v-if="showMessage">
                <div class="top"></div>
                <div class="wrap left">
                  <h3>A może zajrzysz do słowniczka?</h3>
                </div>
                <div class="bottom"></div>
              </div>
            </div>
              <div id="pass" class="passcode" :class="{ 'dictionary-is-open': isOpen }"  ref="code" v-if="showGameCode">
                <p class="slot" v-if="letter != '_'" v-for="(letter, index) in code" :key="letter.index">
                  <span ref="slot" :data-id="letter" :class="'slot_in slot_'+ letter">
                    <span v-if="index > 0 && index != code.length -1 && letter != '_'">
                      <span class="item">{{letter}}</span>
                    </span>
                    <span v-else >{{letter}}</span>
                  </span>
                </p>
              </div>
              <ul class="letters" v-if="showGame">
                <li class="letters-item" ref="letterKey" v-for="(letter, index) in this.letters" :class="{ active: index === activeItem}">
                  <button class="keyboard"  ref="cards" @click="selectLetter(letter , index)" >
                    <span>{{letter}}</span>
                  </button>
                </li>
              </ul>

            <div class="step-bar" v-if="showGame">
              <div class="statusgamebar">
                <div class="statusgamebar-wrap">
                  <div :style="'width:'+ statbar+'%'" class="status-bar"></div>
                </div>
              </div>
              <span>{{currentStep}}/{{setupGame.hangmanLong}}</span>
            </div>
          </div>
        </div>
        <dictionary @stopTimer="stopTimer = $event" @isOpen="isOpen = $event"></dictionary>
      </div>
    </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import {gsap, TimelineLite} from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin'
import MissionName from '@/components/missionName';
import GameTimer from '@/components/gameTimer';
import LifeStatus from '@/components/life';
import Dictionary from "@/components/dictionary";
import GameIntro from '@/organism/OrganismGameIntro.vue';
import GameLvl from '@/organism/OrganismSelectLevel.vue';
import GameRules from '@/organism/OrganismGameRules';
import GameOrder from "@/organism/OrganismGameGetOrder";
import GameMap from "@/organism/OrganismGameMap";
import Hero from "@/molecules/MoleculeHeroAvatar";
gsap.registerPlugin(CSSPlugin);
export default {
name: "GameOne",
  data () {
    return {
      views: null,
      code: null,
      codeSpace:false,
      card: null,
      replayCard: false,
      letters: null,
      hideStack: [],
      checkedLetter: null,
      steps: null,
      life: 3,
      stopTimer:false,
      hangmanLong: null,
      stepsGame: 1,
      activeKey:false,
      showCode: false,
      showLabel: false,
      showGame: true,
      showGameCode: true,
      endGame: false,
      showGameAccess: false,
      showGameMap: false,
      missionName:null,
      activeItem: null,
      currentStep: 1,
      allSteps:null,
      gameOver:false,
      lifeDown:false,
      showMessage:false,
      audio: null,
      isOpen:false,
      statbar:null,
      playerDone:false,
      arrayCode: [],
      view:null,
      GameActiveData: null,
      gamenameGTM: '',
    }
  },
  methods: {
    ...mapMutations(['SET_ACTIVE_VIEW','SET_GAMEONE_CODE','SET_GAMEONE_HIDE', 'SET_GAMEONE_STEP','SET_GAME_DATA']),
    ...mapActions([ 'startGame','audioPlayer','stopAudio']),
      selectLetter(paylod, index){
        this.checkedLetter = paylod;
        gsap.fromTo(this.$refs.cards[index], {
          autoAlpha: 1
        }, { autoAlpha: 0.3, duration: 0.35  });
        let sound = new Howl({
          src: [require('@/assets/audio/bankoslowka/litery/'+ paylod +'.mp3')]
        });
        sound.play();
        if(!this.hideStack.includes(paylod)) {
          this.life--;
          this.stopAudio();
          this.audioPlayer({
            'url': [
              '/bankoslowka/koniec_gry/utrata.mp3'
            ],
          })
        }
      },
      goNextStep(){
        this.stopAudio()
        this.steps++;
        this.currentStep++;
        this.statbar = (this.currentStep / this.setupGame.hangmanLong )* 100;
        this.showLabel = false;
        this.showGameCode = true;
        this.showGame = true;
        this.checkedLetter = null;
        this.life = 3; //

        if (this.setupGame.gameType == 1){
          this.gamenameGTM = "Pieniądze od podszewki"
        }else if(this.setupGame.gameType == 2){
          this.gamenameGTM = "Misja bezpieczeństwo"
        }else if(this.setupGame.gameType == 3){
          this.gamenameGTM = "Zarządzam budżetem"
        }
        this.$gtm.push({
          event: 'ms-gameevent',
          category: "Misja samodzielność",
          action: "Kliknięcie w button - NASTĘPNE SŁOWO ("+this.currentStep+"/"+this.setupGame.hangmanLong+")",
          label: "Pieniądze od podszewki: Gameplay",  //  gameType
        })

      },
      goNextGame(){
        this.stopAudio();
        this.audioPlayer({
          'url': [
            '/famfary/famfary.mp3'
          ],
        })
        let compleated = [
          "BNP_Samodzielniak_10_A.mp3",
          "BNP_Samodzielniak_10_B.mp3",
          "BNP_Samodzielniak_10_C_1.mp3",
          "BNP_Samodzielniak_10_D_1.mp3",
          "BNP_Samodzielniak_10_C_3.mp3",
          "BNP_Samodzielniak_10_C_2.mp3",
          "BNP_Samodzielniak_10_D_2.mp3",
          "BNP_Samodzielniak_10_D_3.mp3"
        ];
        var rand = compleated[Math.floor(Math.random() * compleated.length)];
        let playcompleated = new Howl({
          src: [require('@/assets/audio/bankoslowka/gratulacje/'+rand+'')]
        });
        playcompleated.play();
        this.showGameAccess = true;

        this.$gtm.push({
          event: 'ms-gameevent',
          category: "Misja samodzielność",
          action: "Kliknięcie w button - PRZEJDŹ DALEJ",
          label: "Pieniądze od podszewki: Misja ukończona",  //  gameType
        })

      },
      resetGame(payload){
        this.currentStep = 1;
        this.steps = 0
        this.stepsGame = 1;
        this.SET_ACTIVE_VIEW(payload);
        this.gameOver = false;
        this.life = 3;
        if (this.setupGame.gameType == 1){
          this.gamenameGTM = "Pieniądze od podszewki"
        }else if(this.setupGame.gameType == 2){
          this.gamenameGTM = "Misja bezpieczeństwo"
        }else if(this.setupGame.gameType == 3){
          this.gamenameGTM = "Zarządzam budżetem"
        }
        this.$gtm.push({
          event: 'ms-gameevent',
          category: "Misja samodzielność",
          action: "Kliknięcie w button - SPROBÓJ JESZCZE RAZ",
          label: this.gamenameGTM+": Przegrana",  //  gameType
        })
      },
      rePlay(){
        this.stopAudio();
        let cardsRePlay = new Howl({
          src: [require('@/assets/audio/bankoslowka/karty/'+this.card.audio+'')]
        });
        cardsRePlay.play();
      }
  },
  watch:{
    showMessage(){
      setTimeout(function(scope) {
        scope.showMessage = false;
      }, 2000, this);
    },
    lifeDown(){
      this.life--;
    },
    showLabel(){
      if(this.showLabel == true){
        this.audioPlayer({
          'url': [
            '/bankoslowka/karty/'+this.card.audio+'',
            '/bankoslowka/ogolne/nastepne-slowo.mp3'
          ],
        })
      }
    },
    checkedLetter(){
        const array = this.hideStack;
        let i;
        for (i = 0; i < this.$refs.slot.length; i++ ){
          let letterChecked = this.checkedLetter;
          let id = this.$refs.slot[i].dataset.id
          if(letterChecked == id){
            this.$refs.slot[i].classList.value = 'showLetter';
          }
        }
        let elDel = this.checkedLetter;
        for (let a = array.length; a >= 0; a--) {
          if (array[a] === elDel) {
            array.splice(a, 1);
          }
        }
        this.activeKey = true;
    },
    life(){
        const lifestatus = this.life;
        if(lifestatus === 0){
          this.gameOver = true;
          this.audioPlayer({
            'url': ['/bankoslowka/koniec_gry/BNP_Samodzielniak_11_B-straciles-3-zycia.mp3'],
          })
        }
    },
    hideStack(){
      const stokelength = this.hideStack.length;
      if ( stokelength === 0){
        setTimeout(function(scope) {
          scope.showCode = true;
          scope.showGame = false;
          if (window.innerWidth < 800) {
            gsap.fromTo(scope.$refs.code, { scale: 1 }, {
              scale: 1.1,
              duration: 0.35,
              yoyo: true,
              repeat: 2
            });
          }else{
            gsap.fromTo(scope.$refs.code, { scale: 1 }, {
              scale: 1.2,
              duration: 0.35,
              yoyo: true,
              repeat: 2
            });
          }
          var sounds = [
            "BNP_Samodzielniak_8_A_1.mp3",
            "BNP_Samodzielniak_8_A_2.mp3",
            "BNP_Samodzielniak_8_A_3.mp3",
            "BNP_Samodzielniak_8_B_1.mp3",
            "BNP_Samodzielniak_8_B_2.mp3",
            "BNP_Samodzielniak_8_B_3.mp3",
            "BNP_Samodzielniak_8_C_2.mp3",
            "BNP_Samodzielniak_8_C_1.mp3",
            "BNP_Samodzielniak_8_C_3.mp3",
            "BNP_Samodzielniak_8_D_1.mp3",
            "BNP_Samodzielniak_8_D_2.mp3",
            "BNP_Samodzielniak_8_D_3.mp3",
            "BNP_Samodzielniak_8_E_1.mp3",
            "BNP_Samodzielniak_8_E_2.mp3",
            "BNP_Samodzielniak_8_E_3.mp3",
            "BNP_Samodzielniak_8_F_1.mp3",
            "BNP_Samodzielniak_8_F_2.mp3",
            "BNP_Samodzielniak_8_F_3.mp3"
          ];
          let randSounds = sounds[Math.floor(Math.random() * sounds.length)];
          scope.audioPlayer({
            'url': [
              '/bankoslowka/slowko_zaliczone/'+randSounds+''
            ],
          })
          scope.$confetti.stop();
        }, 300, this);
        setTimeout(function(scope) {
          scope.showGameCode = false;
          scope.showLabel = true;
          scope.$confetti.stop();
        }, 2500, this);
        this.stepsGame++;
      }
    },

    stepsGame(){
      if (this.stepsGame == this.setupGame.hangmanLong + 1){
        this.endGame = true;
      }
    },
    showGameAccess(){
      setTimeout(function(scope) {
        scope.showGameAccess = false;
        scope.showGameMap = true;
      }, 3500, this);
    },

    hangmanGameActiveData(){
      this.hideStack = [];
      this.steps = this.hangmanGame.step;
      this.card = this.hangmanGameActiveData[this.steps];
      this.letters = this.hangmanGameActiveData[this.steps].letters;
      this.code = this.hangmanGameActiveData[this.steps].code
      let result = this.code.slice(1,-1);
      let i;
      for (i = 0; i < result.length; i ++){
        if (result[i] != '_'){
          this.hideStack.push(result[i]);
        }
      }
    },
    steps(){
      if (this.steps > 0){
      this.card = this.hangmanGameActiveData[this.steps];
      this.letters = this.hangmanGameActiveData[this.steps].letters;
      this.code = this.hangmanGameActiveData[this.steps].code
      let result = this.code.slice(1,-1);
      let i;
        for (i = 0; i < result.length; i ++){
          if (result[i] != '_'){
            this.hideStack.push(result[i]);
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['setupGame','hangmanGame', 'hangmanGameActiveData']),
  },

  mounted() {
    this.steps = this.hangmanGame.step;
    this.missionName = this.hangmanGame.missionName;
    this.hangmanLong = this.setupGame.hangmanLong;
    this.statbar = (this.currentStep / this.setupGame.hangmanLong )*100;
  },
  components: {
    GameOrder,
    GameMap,
    Hero,
    Dictionary,
    GameIntro,
    GameLvl,
    GameRules,
    MissionName,
    LifeStatus,
    GameTimer
  },
}
</script>

